<!-- Label Template -->
<ng-template #labelTemplate>
  @if (props.label) {
    <label [attr.for]="id"
           [class.form-label]="true"
           [class.input-inline-label]="labelPosition === 'inline'"
           [style.width]="labelPosition === 'inline' ? (props.labelWidth || '150px') : null">
      {{ props.label }}
      @if (required) {
        <span class="text-danger">*</span>
      }
    </label>
  }
</ng-template>

<!-- Textarea Field Template -->
<ng-template #textareaFieldTemplate>
  <textarea [id]="id"
            [formControl]="formControl"
            [formlyAttributes]="field"
            class="form-control"
            [class.is-invalid]="showError"
            [placeholder]="placeholder"
            [readonly]="readonly"
            [rows]="rows"
            [attr.maxlength]="maxLength"
            [attr.minlength]="minLength"></textarea>

  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }

  @if (showError) {
    <div class="invalid-feedback d-block">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  }
</ng-template>

<!-- Main Layout -->
<div class="mb-3"
     [class.input-inline]="labelPosition === 'inline'">
  @if (labelPosition === 'inline') {
    <div class="input-inline-container">
      <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
      <div class="input-inline-field">
        <ng-container *ngTemplateOutlet="textareaFieldTemplate"></ng-container>
      </div>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
    <ng-container *ngTemplateOutlet="textareaFieldTemplate"></ng-container>
  }
</div>